import React from "react";
import ImageCarousel from "../components/ImageCarousel";
import ChoosePanel from "../components/ChoosePanel";
import Services from "../components/Services";
import CTASection from "../components/CTASection";
import OptimizedServices from "../components/OptimizedServices";
import StatsCounter from "../components/StatsCounter";
import BrandCarousel from "../components/BrandCarousel";
import ContactSection from "../components/ContactSection";
import FAQ from "../components/FAQ";

const HomePage = () => {
  return (
    <>
      <ImageCarousel />
      {/* Animated Background Wrapper */}
      <section className="animated-bg">
        <ChoosePanel />
      </section>
      <Services />
      <CTASection />
      <OptimizedServices />
      <StatsCounter />
      <BrandCarousel />
      <ContactSection />
      <FAQ />
      {/* Enhanced SEO Content Section */}
      <section
        style={{
          background: "#f7f8fc",
          padding: "100px 20px",
        }}
      >
        <div
          style={{
            maxWidth: "1250px",
            margin: "0 auto",
          }}
        >
          <div style={{ textAlign: "center", marginBottom: "70px" }}>
            <h2
              style={{
                fontSize: "44px",
                fontWeight: "700",
                color: "#111111",
                marginBottom: "20px",
              }}
            >
              Betting Panel Provider & Master Panel Provider India
            </h2>

            <p
              style={{
                maxWidth: "850px",
                margin: "0 auto",
                color: "#555",
                fontSize: "18px",
                lineHeight: "1.8",
              }}
            >
              Structured betting infrastructure, scalable backend systems,
              real-time APIs, and operational management solutions designed for
              modern online betting environments.
            </p>
          </div>

          {/* Card 1 */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "40px",
              background: "#fff",
              borderRadius: "18px",
              padding: "45px",
              marginBottom: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
              flexWrap: "wrap",
            }}
          >
            <div style={{ flex: "1", minWidth: "300px" }}>
              <img
                src="https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjdMIKwYiAGe-L4LC_dHL-jUa-wS-ODSsdHqWGHwPVdjPnAjgZTz9mtM0vGYGaalmKdC52VZkt5qPIrU4x46vAyFJWVxZky_JHrMXnsFUqt06oiF_W36HONrBPD_Yf-AbBCiMCSY1fO7mGl-Ts1qXgrtfZSA8A_YpMf6Cgo_WZH8d03-KZfz41P5DfN6rI/s16000/bettingpanelprovider.png"
                alt="Betting Panel Provider"
                style={{
                  width: "100%",
                  borderRadius: "14px",
                  objectFit: "cover",
                }}
              />
            </div>

            <div style={{ flex: "1", minWidth: "300px" }}>
              <h3
                style={{
                  fontSize: "32px",
                  marginBottom: "20px",
                  color: "#111",
                }}
              >
                <a
                  href="https://alexgoa.com/betting-panel-provider/"
                  style={{
                    color: "#111",
                    textDecoration: "none",
                  }}
                >
                  Betting Panel Provider
                </a>
              </h3>

              <p style={{ color: "#555", lineHeight: "1.9" }}>
                Online betting platforms require stable backend systems capable
                of managing users, betting activity, wallet operations, and
                real-time synchronization efficiently. A{" "}
                <a
                  href="https://alexgoa.com/betting-panel-provider/"
                  style={{ color: "#0A336E", fontWeight: "600" }}
                >
                  betting panel provider
                </a>{" "}
                helps businesses manage these operations through centralized
                backend systems designed for scalable betting environments.
              </p>

              <p style={{ color: "#555", lineHeight: "1.9" }}>
                Modern betting platforms rely heavily on structured
                infrastructure, operational stability, and API integration to
                maintain smooth performance during live betting activity and
                high-traffic periods.
              </p>

              <a
                href="https://api.whatsapp.com/send/?phone=447347631909&text=Hello+%EF%BF%BD%0A%0AI%E2%80%99m+interested+in+getting+a+B2B+%2C+B2C+panel.%0A%0APlease+share+complete+details.%0AThank+you.&type=phone_number&app_absent=0"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button
                  style={{
                    marginTop: "20px",
                    background: "#0A336E",
                    color: "#fff",
                    border: "none",
                    padding: "14px 30px",
                    borderRadius: "8px",
                    fontSize: "16px",
                    fontWeight: "600",
                    cursor: "pointer",
                  }}
                >
                  Get Betting Panel Today
                </button>
              </a>
            </div>
          </div>

          {/* Card 2 */}
          <div
            style={{
              display: "flex",
              flexDirection: "row-reverse",
              alignItems: "center",
              gap: "40px",
              background: "#fff",
              borderRadius: "18px",
              padding: "45px",
              marginBottom: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
              flexWrap: "wrap",
            }}
          >
            <div style={{ flex: "1", minWidth: "300px" }}>
              <img
                src="https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhNPq_afLMdo2LmlrmCPUmTCyttYriS3IN2-oD121Nymb1KP0yBlgwo-bs3p9XhsFnvdbSS4pjEPZi0mSfoCzrN2TxDzPGEP_MHkQH6yTkQuMjJ0WjLkW9zXNUq0iHunFfx_jUQra0jSMUMbh7monKBaXOCiiIx8iiwJACAuetdNv8eVN1jenUG5KEl4L0/s16000/masterpanelproviderindia.png"
                alt="Master Panel Provider India"
                style={{
                  width: "100%",
                  borderRadius: "14px",
                }}
              />
            </div>

            <div style={{ flex: "1", minWidth: "300px" }}>
              <h3
                style={{
                  fontSize: "32px",
                  marginBottom: "20px",
                  color: "#111",
                }}
              >
                <a
                  href="https://alexgoa.com/master-panel-provider-india/"
                  style={{
                    color: "#111",
                    textDecoration: "none",
                  }}
                >
                  Master Panel Provider India
                </a>
              </h3>

              <p style={{ color: "#555", lineHeight: "1.9" }}>
                Master panel systems are designed to support large-scale betting
                operations through centralized backend controls, user
                management, and real-time operational monitoring.
              </p>

              <p style={{ color: "#555", lineHeight: "1.9" }}>
                A{" "}
                <a
                  href="https://alexgoa.com/master-panel-provider-india/"
                  style={{ color: "#0A336E", fontWeight: "600" }}
                >
                  master panel provider India
                </a>{" "}
                solution helps businesses simplify backend operations while
                supporting scalable betting infrastructure and operational
                consistency.
              </p>

              <a
                href="https://api.whatsapp.com/send/?phone=447347631909&text=Hello+%EF%BF%BD%0A%0AI%E2%80%99m+interested+in+getting+a+B2B+%2C+B2C+panel.%0A%0APlease+share+complete+details.%0AThank+you.&type=phone_number&app_absent=0"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button
                  style={{
                    marginTop: "20px",
                    background: "#0A336E",
                    color: "#fff",
                    border: "none",
                    padding: "14px 30px",
                    borderRadius: "8px",
                    fontSize: "16px",
                    fontWeight: "600",
                    cursor: "pointer",
                  }}
                >
                  Master Panel Here
                </button>
              </a>
            </div>
          </div>

          {/* Card 3 */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "40px",
              background: "#fff",
              borderRadius: "18px",
              padding: "45px",
              marginBottom: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
              flexWrap: "wrap",
            }}
          >
            <div style={{ flex: "1", minWidth: "300px" }}>
              <img
                src="https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEg3jahjTEcU1jAm_fvWnC8XIW563193SsJSsIdUy-2YQW95NSGFSA4tsKrXVEUwGVw2fAd8Aedz1k9MlAcFW9PoPFYRh_35XrpC7GTvEbE3KmLKXiFwhG87jwQsyNBzcLZcJBMy3eNDZhBDA_T1CDxY5JCGUURXJp4Oz0OlXQURWG1ZX7vwUBdPfkh0DvU/s16000/rentalbettingidpanel.png"
                alt="Rental Betting ID Panel"
                style={{
                  width: "100%",
                  borderRadius: "14px",
                }}
              />
            </div>

            <div style={{ flex: "1", minWidth: "300px" }}>
              <h3
                style={{
                  fontSize: "32px",
                  marginBottom: "20px",
                  color: "#111",
                }}
              >
                <a
                  href="https://alexgoa.com/rental-betting-id-panel/"
                  style={{
                    color: "#111",
                    textDecoration: "none",
                  }}
                >
                  Rental Betting ID Panel
                </a>
              </h3>

              <p style={{ color: "#555", lineHeight: "1.9" }}>
                Rental betting ID panel systems are designed to simplify betting
                operations through centralized user and transaction management.
              </p>

              <p style={{ color: "#555", lineHeight: "1.9" }}>
                Structured{" "}
                <a
                  href="https://alexgoa.com/rental-betting-id-panel/"
                  style={{ color: "#0A336E", fontWeight: "600" }}
                >
                  rental betting ID panel
                </a>{" "}
                systems support scalable backend infrastructure and operational
                flexibility for modern betting environments.
              </p>

              <a
                href="https://api.whatsapp.com/send/?phone=447347631909&text=Hello+%EF%BF%BD%0A%0AI%E2%80%99m+interested+in+getting+a+B2B+%2C+B2C+panel.%0A%0APlease+share+complete+details.%0AThank+you.&type=phone_number&app_absent=0"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button
                  style={{
                    marginTop: "20px",
                    background: "#0A336E",
                    color: "#fff",
                    border: "none",
                    padding: "14px 30px",
                    borderRadius: "8px",
                    fontSize: "16px",
                    fontWeight: "600",
                    cursor: "pointer",
                  }}
                >
                  Get Betting ID Panel
                </button>
              </a>
            </div>
          </div>

          {/* Card 4 */}
          <div
            style={{
              display: "flex",
              flexDirection: "row-reverse",
              alignItems: "center",
              gap: "40px",
              background: "#fff",
              borderRadius: "18px",
              padding: "45px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
              flexWrap: "wrap",
            }}
          >
            <div style={{ flex: "1", minWidth: "300px" }}>
              <img
                src="https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEiG_tudyf5WLbyW0E4RBUCVU0-rkGq0VTouiNwpx4csP74GTjrbSMnlzFPRVeeItkbYEnw66MoVSfIqe8rT13rJ8yQv4aTu_BUWN1tPwkT97o1W3aqxJ_92ICQqaiBkX6v3w27dLtCYnlbzpvOeQZDrUj4bZ5j-lQOMT5-35zkq51Csdu2oNI67mH90rlM/s16000/reddyannapanelprovider.png"
                alt="Reddy Anna Panel Provider"
                style={{
                  width: "100%",
                  borderRadius: "14px",
                }}
              />
            </div>

            <div style={{ flex: "1", minWidth: "300px" }}>
              <h3
                style={{
                  fontSize: "32px",
                  marginBottom: "20px",
                  color: "#111",
                }}
              >
                <a
                  href="https://alexgoa.com/reddy-anna-panel-provider/"
                  style={{
                    color: "#111",
                    textDecoration: "none",
                  }}
                >
                  Reddy Anna Panel Provider
                </a>
              </h3>

              <p style={{ color: "#555", lineHeight: "1.9" }}>
                Reddy Anna panel systems support online betting operations
                through structured backend management, API integration, and
                operational control systems.
              </p>

              <p style={{ color: "#555", lineHeight: "1.9" }}>
                Modern betting platforms depend on real-time systems and
                scalable infrastructure to maintain smooth performance during
                live betting activity and high user traffic periods.
              </p>

              <a
                href="https://api.whatsapp.com/send/?phone=447347631909&text=Hello+%EF%BF%BD%0A%0AI%E2%80%99m+interested+in+getting+a+B2B+%2C+B2C+panel.%0A%0APlease+share+complete+details.%0AThank+you.&type=phone_number&app_absent=0"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button
                  style={{
                    marginTop: "20px",
                    background: "#0A336E",
                    color: "#fff",
                    border: "none",
                    padding: "14px 30px",
                    borderRadius: "8px",
                    fontSize: "16px",
                    fontWeight: "600",
                    cursor: "pointer",
                  }}
                >
                  Get Reddy Anna Panel Today
                </button>
              </a>
            </div>
          </div>
        </div>
      </section>
      {/* Homepage SEO Authority Section */}
      <section
        style={{
          background: "#f7f8fc",
          padding: "100px 20px",
        }}
      >
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
          }}
        >
          {/* Heading */}
          <div style={{ textAlign: "center", marginBottom: "70px" }}>
            <h2
              style={{
                fontSize: "46px",
                fontWeight: "700",
                color: "#111",
                marginBottom: "20px",
                lineHeight: "1.3",
              }}
            >
              Built for Modern Online Betting Platforms
            </h2>

            <p
              style={{
                fontSize: "18px",
                color: "#555",
                lineHeight: "1.9",
                maxWidth: "900px",
                margin: "0 auto",
              }}
            >
              Simple, scalable, and real-time betting systems designed to
              support smooth platform management, user activity, wallet
              operations, and live betting infrastructure.
            </p>
          </div>

          {/* Main Content Wrapper */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "18px",
              padding: "60px",
              boxShadow: "0 10px 40px rgba(0,0,0,0.05)",
            }}
          >
            {/* Intro */}
            <p
              style={{
                fontSize: "17px",
                color: "#555",
                lineHeight: "2",
                marginBottom: "35px",
              }}
            >
              The online betting industry continues expanding rapidly across
              digital markets, increasing demand for structured backend systems
              capable of handling betting activity, user management, wallet
              operations, and real-time synchronization efficiently. Modern
              betting platforms are no longer limited to simple website systems.
              Businesses now require scalable operational infrastructure that
              supports stable betting environments, API integration, and
              centralized management systems.
            </p>

            <p
              style={{
                fontSize: "17px",
                color: "#555",
                lineHeight: "2",
                marginBottom: "50px",
              }}
            >
              Alex Goa focuses on structured betting panel systems designed to
              help businesses manage betting operations more efficiently through
              stable backend infrastructure, real-time operational controls, and
              scalable management environments.
            </p>

            {/* How Betting Systems Work */}
            <div style={{ marginBottom: "55px" }}>
              <h3
                style={{
                  fontSize: "32px",
                  marginBottom: "20px",
                  color: "#111",
                }}
              >
                How Betting Panel Systems Work
              </h3>

              <p
                style={{ color: "#555", lineHeight: "2", marginBottom: "20px" }}
              >
                Modern betting platforms operate through backend systems
                connected to real-time APIs, wallet systems, operational
                dashboards, and user management environments. These systems
                process betting activity, synchronize live odds, manage
                transactions, and maintain operational stability continuously
                during sporting events and high-traffic periods.
              </p>

              <p style={{ color: "#555", lineHeight: "2" }}>
                Structured betting systems simplify backend operations by
                centralizing user controls, betting activity management, and
                reporting systems into one operational environment. This allows
                businesses to maintain smoother betting operations while
                supporting long-term scalability.
              </p>
            </div>

            {/* Features */}
            <div style={{ marginBottom: "55px" }}>
              <h3
                style={{
                  fontSize: "32px",
                  marginBottom: "25px",
                  color: "#111",
                }}
              >
                Features of Modern Betting Panels
              </h3>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit,minmax(250px,1fr))",
                  gap: "20px",
                }}
              >
                {[
                  "Real-Time Betting Management",
                  "Wallet & Transaction Systems",
                  "API Integration Support",
                  "User & Betting ID Management",
                  "Mobile-Friendly Infrastructure",
                  "Secure Backend Controls",
                  "Operational Reporting Systems",
                  "Scalable Betting Infrastructure",
                ].map((item, index) => (
                  <div
                    key={index}
                    style={{
                      background: "#f7f8fc",
                      padding: "18px 20px",
                      borderRadius: "10px",
                      fontSize: "16px",
                      color: "#333",
                      fontWeight: "500",
                    }}
                  >
                    ✔ {item}
                  </div>
                ))}
              </div>
            </div>

            {/* API Section */}
            <div style={{ marginBottom: "55px" }}>
              <h3
                style={{
                  fontSize: "32px",
                  marginBottom: "20px",
                  color: "#111",
                }}
              >
                API Integration and Real-Time Betting Systems
              </h3>

              <p
                style={{ color: "#555", lineHeight: "2", marginBottom: "20px" }}
              >
                Real-time betting environments depend heavily on API
                integration. APIs provide live odds updates, sports
                synchronization, casino game integration, and betting market
                information continuously throughout live sporting events.
              </p>

              <p style={{ color: "#555", lineHeight: "2" }}>
                Stable API systems help maintain faster synchronization,
                accurate betting updates, and smoother operational performance.
                As online betting markets continue growing globally, API
                reliability remains one of the most important parts of modern
                betting infrastructure.
              </p>
            </div>

            {/* Mobile Infrastructure */}
            <div style={{ marginBottom: "55px" }}>
              <h3
                style={{
                  fontSize: "32px",
                  marginBottom: "20px",
                  color: "#111",
                }}
              >
                Mobile-Friendly Betting Infrastructure
              </h3>

              <p
                style={{ color: "#555", lineHeight: "2", marginBottom: "20px" }}
              >
                Most betting users now access platforms through mobile devices.
                Because of this, betting systems must support responsive
                layouts, stable mobile performance, and fast operational
                synchronization.
              </p>

              <p style={{ color: "#555", lineHeight: "2" }}>
                Mobile-friendly betting infrastructure improves user
                accessibility, navigation experience, and real-time betting
                interaction. Platforms optimized for mobile environments are
                generally better positioned to support long-term user
                engagement.
              </p>
            </div>

            {/* SEO */}
            <div style={{ marginBottom: "55px" }}>
              <h3
                style={{
                  fontSize: "32px",
                  marginBottom: "20px",
                  color: "#111",
                }}
              >
                SEO and Digital Visibility
              </h3>

              <p
                style={{ color: "#555", lineHeight: "2", marginBottom: "20px" }}
              >
                SEO plays an important role in helping betting platforms improve
                visibility organically. Many betting businesses rely on search
                traffic to attract users across competitive digital betting
                markets.
              </p>

              <p style={{ color: "#555", lineHeight: "2" }}>
                Long-term SEO strategies generally focus on structured content,
                technical optimization, internal linking systems, scalable
                website architecture, and topic-focused authority building
                designed to support sustainable digital growth.
              </p>
            </div>

            {/* Security */}
            <div style={{ marginBottom: "55px" }}>
              <h3
                style={{
                  fontSize: "32px",
                  marginBottom: "20px",
                  color: "#111",
                }}
              >
                Security and Operational Stability
              </h3>

              <p
                style={{ color: "#555", lineHeight: "2", marginBottom: "20px" }}
              >
                Modern betting platforms continuously handle transactions,
                wallet systems, user activity, and operational data. Stable
                infrastructure and secure backend systems are important for
                maintaining operational consistency and smoother betting
                performance.
              </p>

              <p style={{ color: "#555", lineHeight: "2" }}>
                Reliable betting infrastructure focuses on secure transaction
                handling, protected user access, scalable backend environments,
                and operational stability designed to support long-term platform
                growth.
              </p>
            </div>

            {/* Why Choose */}
            <div style={{ marginBottom: "55px" }}>
              <h3
                style={{
                  fontSize: "32px",
                  marginBottom: "20px",
                  color: "#111",
                }}
              >
                Why Businesses Choose Alex Goa
              </h3>

              <p
                style={{ color: "#555", lineHeight: "2", marginBottom: "20px" }}
              >
                Businesses operating in digital betting markets require systems
                capable of supporting operational scalability, stable
                infrastructure, and real-time betting management. Alex Goa
                focuses on structured betting systems designed to simplify
                backend operations while supporting long-term operational
                efficiency.
              </p>

              <p style={{ color: "#555", lineHeight: "2" }}>
                Our focus remains on scalable betting panel systems, operational
                stability, API integration, mobile-friendly infrastructure, and
                backend management environments designed for modern betting
                platforms.
              </p>
            </div>

            {/* Future */}
            <div style={{ marginBottom: "50px" }}>
              <h3
                style={{
                  fontSize: "32px",
                  marginBottom: "20px",
                  color: "#111",
                }}
              >
                Future of Betting Panel Systems
              </h3>

              <p
                style={{ color: "#555", lineHeight: "2", marginBottom: "20px" }}
              >
                Betting infrastructure continues evolving through automation,
                AI-driven systems, and improved real-time operational
                management. Modern betting platforms are increasingly focusing
                on scalable systems capable of handling growing operational
                demands efficiently.
              </p>

              <p style={{ color: "#555", lineHeight: "2" }}>
                Future betting systems are expected to focus more on
                mobile-first infrastructure, AI-based analytics, faster backend
                processing, and improved real-time synchronization designed for
                long-term scalability.
              </p>
            </div>

            {/* Keyword Section */}
            <div
              style={{
                background: "#f7f8fc",
                padding: "35px",
                borderRadius: "16px",
                marginTop: "40px",
              }}
            >
              <h3
                style={{
                  fontSize: "30px",
                  marginBottom: "25px",
                  color: "#111",
                }}
              >
                Betting Panel Solutions
              </h3>

              <p
                style={{ color: "#555", lineHeight: "2", marginBottom: "20px" }}
              >
                <a
                  href="https://alexgoa.com/betting-panel-provider/"
                  style={{ color: "#0A336E", fontWeight: "600" }}
                >
                  Betting Panel Provider
                </a>{" "}
                systems help businesses manage online betting operations through
                scalable backend infrastructure and operational controls.
              </p>

              <p
                style={{ color: "#555", lineHeight: "2", marginBottom: "20px" }}
              >
                <a
                  href="https://alexgoa.com/master-panel-provider-india/"
                  style={{ color: "#0A336E", fontWeight: "600" }}
                >
                  Master Panel Provider India
                </a>{" "}
                solutions support real-time betting environments and multi-user
                operational management systems.
              </p>

              <p
                style={{ color: "#555", lineHeight: "2", marginBottom: "20px" }}
              >
                <a
                  href="https://alexgoa.com/rental-betting-id-panel/"
                  style={{ color: "#0A336E", fontWeight: "600" }}
                >
                  Rental Betting ID Panel
                </a>{" "}
                systems simplify betting management through centralized user and
                transaction controls.
              </p>

              <p style={{ color: "#555", lineHeight: "2" }}>
                <a
                  href="https://alexgoa.com/reddy-anna-panel-provider/"
                  style={{ color: "#0A336E", fontWeight: "600" }}
                >
                  Reddy Anna Panel Provider
                </a>{" "}
                infrastructure supports scalable betting operations and
                real-time betting management systems.
              </p>
            </div>

            {/* CTA */}
            <div style={{ textAlign: "center", marginTop: "60px" }}>
              <a
                href="https://api.whatsapp.com/send/?phone=447347631909&text=Hello+%EF%BF%BD%0A%0AI%E2%80%99m+interested+in+getting+a+B2B+%2C+B2C+panel.%0A%0APlease+share+complete+details.%0AThank+you.&type=phone_number&app_absent=0"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button
                  style={{
                    background: "#0A336E",
                    color: "#fff",
                    border: "none",
                    padding: "16px 40px",
                    borderRadius: "8px",
                    fontSize: "17px",
                    fontWeight: "600",
                    cursor: "pointer",
                  }}
                >
                  Start Your Betting Platform Today
                </button>
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomePage;
